import { Rule } from './rule';

export class PlinkoCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.plinko.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.plinko.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.plinko.header-2',
      body: [{ type: 'text', content: 'components.cheat-sheet.plinko.body-2a' }],
    },
    {
      title: 'components.cheat-sheet.plinko.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.plinko.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-3c' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-3d' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-3e' },
      ],
    },
    {
      title: 'components.cheat-sheet.plinko.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4d' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4e' },
        { type: 'text', content: 'components.cheat-sheet.plinko.body-4f' },
      ],
    },
  ];
}
